import { GAME_CONSTANTS } from '../data/gameConstants';

export const calculateTrainingCost = (level) => {
  const { BASE_COST, COST_MULTIPLIER } = GAME_CONSTANTS.WORK.TRAINING;
  return Math.floor(BASE_COST * Math.pow(COST_MULTIPLIER, level - 1));
};

export const calculateClickValue = (state) => {
  const baseValue = GAME_CONSTANTS.WORK.BASE_CLICK_VALUE;
  const trainingMultiplier = Math.pow(GAME_CONSTANTS.WORK.TRAINING.VALUE_MULTIPLIER, state.trainingLevel - 1);
  return Math.floor(baseValue * trainingMultiplier * state.clickMultiplier);
};

export const calculateNextImprovement = (currentLevel, currentMultiplier) => {
  const currentValue = calculateClickValue({ trainingLevel: currentLevel, clickMultiplier: currentMultiplier });
  const nextValue = calculateClickValue({ trainingLevel: currentLevel + 1, clickMultiplier: currentMultiplier });
  return nextValue - currentValue;
};

export const calculateTrainingProgress = (state) => {
  const currentCost = calculateTrainingCost(state.trainingLevel);
  const percentage = Math.min((state.money / currentCost) * 100, 100);
  
  // Calculate time to next training level
  const timeToNext = state.incomePerSecond > 0 
    ? (currentCost - state.money) / state.incomePerSecond 
    : Infinity;

  return {
    percentage,
    timeToNext
  };
};